module.exports = __webpack_public_path__ + "img/solarroof_mob.766a1fd.webp";